import React from "react";
import type { DividerBlock } from '../../domain/types';
import { resolveDividerColor } from '../../domain/text-theme';
import { padStyle, presentationTableProps } from '../table';
import type { BlockRenderProps } from './types';

export function renderDividerBlock({
  block,
  textTheme,
}: BlockRenderProps & { block: DividerBlock }) {
  const color = resolveDividerColor(block, textTheme);
  return (
    <table {...presentationTableProps()}>
      <tbody>
        <tr>
          <td style={padStyle(block.padding)}>
            <table
              {...presentationTableProps()}
              {...({ align: 'center' } as React.TableHTMLAttributes<HTMLTableElement>)}
              width={`${block.widthPct}%`}
              style={{
                width: `${block.widthPct}%`,
                margin: '0 auto',
                borderCollapse: 'collapse',
              }}>
              <tbody>
                <tr>
                  <td
                    style={{
                      borderTop: `${block.thickness}px ${block.style} ${color}`,
                      fontSize: 0,
                      lineHeight: 0,
                    }}>
                    &nbsp;
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
